module.exports = __webpack_public_path__ + "static/media/wxz.67e79e12.svg";